export const toggleVisibility = element => {
  element.classList.toggle("dn");
};

export const showElement = element => {
  element.classList.remove("dn");
};



// WEBPACK FOOTER //
// ./js/utils.js